import { render, staticRenderFns } from "./ReservationDetailsWidget.vue?vue&type=template&id=606195d7"
import script from "./ReservationDetailsWidget.vue?vue&type=script&lang=js"
export * from "./ReservationDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports